import AuthImpl from '../../serviceImpl/AuthImpl';

import {UserCreated, UserCreateParams, UserCreateParamsErrors} from '@/domain/services/Auth';

const signUpUseCase = async (userParams: UserCreateParams ): Promise<UserCreated | UserCreateParamsErrors> => {
  return AuthImpl.singup(userParams);
};

export default signUpUseCase;